/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { SimpleCorporateClient } from './platformapi.schemas';

import getAllCorporateClientsMutator from '../custom-axios-instance';

/**
 * Retrieves a list of all corporate clients
 * @summary Get All Corporate Clients
 */
export const getAllCorporateClients = (signal?: AbortSignal) => {
  return getAllCorporateClientsMutator<SimpleCorporateClient[]>({
    url: `${import.meta.env['VITE_API_HOST']}/corporate_clients/all`,
    method: 'GET',
    signal,
  });
};

export const getGetAllCorporateClientsQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/corporate_clients/all`] as const;
};

export const getGetAllCorporateClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllCorporateClients>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAllCorporateClients>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllCorporateClientsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCorporateClients>>> = ({ signal }) =>
    getAllCorporateClients(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllCorporateClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllCorporateClientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllCorporateClients>>
>;
export type GetAllCorporateClientsQueryError = void;

export function useGetAllCorporateClients<
  TData = Awaited<ReturnType<typeof getAllCorporateClients>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllCorporateClients>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCorporateClients>>,
          TError,
          Awaited<ReturnType<typeof getAllCorporateClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllCorporateClients<
  TData = Awaited<ReturnType<typeof getAllCorporateClients>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllCorporateClients>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCorporateClients>>,
          TError,
          Awaited<ReturnType<typeof getAllCorporateClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllCorporateClients<
  TData = Awaited<ReturnType<typeof getAllCorporateClients>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllCorporateClients>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get All Corporate Clients
 */

export function useGetAllCorporateClients<
  TData = Awaited<ReturnType<typeof getAllCorporateClients>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllCorporateClients>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllCorporateClientsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
